/* Khung app HANA One theo MINT NAV KIT v1 + MINT APPS KIT v1 + DOCK (board Mint-Home, -iPad, -Phone). */

.root {
  position: relative;
  display: flex;
  height: 100dvh;
  overflow: hidden;
  background: var(--bg);
  color: var(--tx);
}

/* ───────── Cột menu (sidebar 248 ⇄ rail 64), chuyển mượt (NAV MOTION) ───────── */
.navCol { position: relative; flex-shrink: 0; width: 248px; transition: width 200ms cubic-bezier(0.2, 0.8, 0.2, 1); }
.navCol.isRail { width: 64px; }
.navCol.isLabeled { width: 80px; }
.navCol.isNone { width: 0; }

.side {
  position: relative;
  width: 248px;
  height: 100%;
  box-sizing: border-box;
  padding: 16px 12px 12px;
  display: flex;
  flex-direction: column;
  background: var(--side);
  border-right: 1px solid var(--line);
}
.float {
  position: absolute;
  left: 8px;
  top: 8px;
  bottom: 8px;
  z-index: 40;
  height: auto;
  border-right: 0;
  border-radius: 16px;
  box-shadow: var(--pop);
}
.padNav { width: 300px; left: 10px; top: 10px; bottom: 10px; border-radius: 18px; padding: 16px 12px; }

.sideHead { display: flex; align-items: center; gap: 10px; padding: 0 0 10px 8px; }
.zoneName { flex-grow: 1; min-width: 0; font-size: 15px; font-weight: var(--fw-title); white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }

.ib {
  width: 30px;
  height: 30px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 0;
  border-radius: 9px;
  background: transparent;
  color: var(--lb);
  font: inherit;
  cursor: pointer;
}
.ib[aria-expanded='true'] { background: var(--pri-bg); color: var(--link); }
.ibCtl { width: 32px; height: 32px; background: var(--ctl); color: var(--tx2); }

.navScroll {
  flex-grow: 1;
  min-height: 0;
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: var(--bd) transparent;
  display: flex;
  flex-direction: column;
}
.sec { flex-shrink: 0; height: 30px; box-sizing: border-box; padding: 14px 10px 0; font-size: 11px; font-weight: 600; letter-spacing: 0.06em; color: var(--lb); text-transform: uppercase; }

.secTop { height: 30px; box-sizing: border-box; padding: 6px 10px 0; }

.item,
.grp {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  height: 34px;
  flex-shrink: 0;
  box-sizing: border-box;
  padding: 0 10px;
  border: 0;
  border-radius: 10px;
  background: transparent;
  color: var(--tx2);
  font: inherit;
  font-weight: var(--fw-label);
  text-align: left;
  text-decoration: none;
  white-space: nowrap;
  cursor: pointer;
  transition: background 160ms, color 160ms;
}
.item svg, .grp svg { flex-shrink: 0; }
.item > span:first-of-type, .grp > span:first-of-type { flex-grow: 1; min-width: 0; overflow: hidden; text-overflow: ellipsis; }
.grp { color: var(--tx); font-weight: 600; }
.grp.grpAct { color: var(--link); font-weight: var(--fw-title); }
.grp.grpAct[aria-expanded='false'] { background: var(--pri-bg); }
.item[aria-current='page'] { background: var(--pri-bg); color: var(--link); font-weight: 600; }
.chev { transition: transform 160ms; color: var(--lb); }
.grp[aria-expanded='true'] .chev { transform: rotate(90deg); }
.sub { margin: 1px 0 4px 18px; padding-left: 9px; border-left: 1px solid var(--line); display: flex; flex-direction: column; gap: 1px; }
.sub .item { height: 30px; border-radius: 9px; }
.cnt { font-size: 12px; color: var(--lb); font-weight: 400; }
.sum {
  min-width: 18px;
  height: 18px;
  padding: 0 5px;
  box-sizing: border-box;
  border-radius: 9px;
  background: var(--ctl);
  color: var(--tx2);
  font-size: 11px;
  font-weight: 600;
  line-height: 18px;
  text-align: center;
}
@media (hover: hover) {
  .item:not([aria-current='page']):hover, .grp:hover { background: var(--sub); color: var(--tx); }
  .ib:hover { background: var(--ctl); color: var(--tx); }
}

.me { position: relative; display: flex; align-items: center; gap: 10px; padding: 10px 6px 0; margin-top: 8px; border-top: 1px solid var(--line); }
.av {
  width: 32px;
  height: 32px;
  flex-shrink: 0;
  border-radius: 50%;
  background: var(--pri-bg);
  color: var(--link);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 600;
}
.meTx { flex-grow: 1; min-width: 0; }
.meTx b { display: block; font-weight: var(--fw-label); white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.meTx span { display: block; font-size: 12px; color: var(--lb); white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }

/* ───────── Menu nổi chung (menu người dùng, flyout rail) ───────── */
.scrimClear { position: fixed; inset: 0; z-index: 44; }
.scrim { position: fixed; inset: 0; z-index: 39; background: var(--scrim); }
.menu {
  position: absolute;
  z-index: 46;
  box-sizing: border-box;
  padding: 6px;
  border-radius: 12px;
  background: var(--card);
  color: var(--tx);
  box-shadow: var(--pop);
  display: flex;
  flex-direction: column;
  gap: 1px;
}
.um { left: 0; right: 0; bottom: 52px; }
.mi {
  display: flex;
  align-items: center;
  gap: 10px;
  height: 34px;
  flex-shrink: 0;
  padding: 0 10px;
  border: 0;
  border-radius: 8px;
  background: transparent;
  color: var(--tx);
  font: inherit;
  text-align: left;
  text-decoration: none;
  white-space: nowrap;
  cursor: pointer;
}
.mi svg { flex-shrink: 0; color: var(--lb); }
.miErr { color: var(--err); font-weight: var(--fw-label); }
.miErr svg { color: var(--err); }
.hr { height: 1px; margin: 4px 6px; background: var(--line); }
@media (hover: hover) {
  .mi:hover { background: var(--sub); }
}

/* ───────── Rail 64 ───────── */
.rail { width: 64px; height: 100%; box-sizing: border-box; padding: 8px 0 8px 8px; }
.railIn {
  height: 100%;
  width: 56px;
  box-sizing: border-box;
  padding: 10px 0;
  border-radius: 14px;
  background: var(--side);
  box-shadow: var(--sh);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
  overflow-y: auto;
  scrollbar-width: none;
}
.rb {
  position: relative;
  width: 40px;
  height: 38px;
  flex-shrink: 0;
  border: 0;
  border-radius: 10px;
  background: transparent;
  color: var(--tx2);
  display: flex;
  align-items: center;
  justify-content: center;
  font: inherit;
  cursor: pointer;
  text-decoration: none;
}
.rbCtl { height: 40px; margin-bottom: 4px; background: var(--ctl); }
.rb[aria-current='page'], .rb.rbAct { background: var(--pri-bg); color: var(--link); }
.rb[aria-expanded='true']:not(.rbAct) { background: var(--sub); }
.rsep { width: 24px; height: 1px; flex-shrink: 0; margin: 6px 0; background: var(--line); }
.rdot { position: absolute; top: 5px; right: 7px; width: 8px; height: 8px; border-radius: 50%; background: var(--pri); box-shadow: 0 0 0 2px var(--side); }
.rbEnd { margin-top: auto; }
@media (hover: hover) {
  .rb:not(.rbAct):not([aria-current='page']):hover { background: var(--sub); color: var(--tx); }
}
.fly {
  left: 68px;
  min-width: 200px;
  max-width: 320px;
  padding: 10px 8px;
  border-radius: 14px;
  overflow-y: auto;
}
.flyHead { display: flex; align-items: center; gap: 8px; padding: 0 0 8px 8px; }
.flyHead b { flex-grow: 1; font-weight: var(--fw-title); }

/* ───────── Nội dung ───────── */
.main {
  flex-grow: 1;
  min-width: 0;
  height: 100%;
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: var(--bd) transparent;
  scrollbar-gutter: auto;
}
/* Khung nội dung theo board (biến CW trong Mint-Job / P2P / Booking / Rates): khối giữa, KHÔNG giãn theo màn —
   1280 → 1184 · 1536 → 1240 · 1920 → 1264; trang chi tiết (Mint-JobDetail) và màn bảng dày (QĐ 29/Oct 16:59) 1920 → 1590. Thu sidebar / đóng bảng phải:
   khối vẫn giữ bề ngang và canh giữa, không kéo dãn bảng. Lề tối thiểu hai bên = --pg-x (mainPad của board). */
.bare { overflow: hidden; display: flex; flex-direction: column; }
.content {
  --pg-x: 16px; --cw: 1184px; --pg-top: 22px;
  width: min(100% - 2 * var(--pg-x), var(--cw)); margin-inline: auto;
  padding: var(--pg-top) 0 96px; display: flex; flex-direction: column; gap: 14px;
}
@media (min-width: 1536px) { .content { --pg-x: 24px; --cw: 1240px; } }
@media (min-width: 1800px) { .content { --cw: 1264px; } .content:has(.pageDetail), .content:has(.pageTable) { --cw: 1590px; } }
@media (max-width: 1023px) { .content { --pg-x: 20px; } }
/* bảng phải (Page dock): ≥ 1800 cố định mép phải 372, cao hết màn; khối nội dung 1264 canh giữa phần còn lại */
.dockSlot { min-width: 0; }
@media (min-width: 1800px) {
  .main:has(.dockSlot) { padding-right: 372px; }
  .content:has(.dockSlot) { --cw: 1264px; }
  .dockSlot { position: fixed; top: 0; right: 0; bottom: 0; width: 372px; z-index: 5; background: var(--card); box-shadow: var(--sh); overflow-y: auto; }
  .dockSlot.dockSlot > * { width: 100%; min-height: 100%; border-radius: 0; box-shadow: none; box-sizing: border-box; }
}

/* <Page kind>: list / detail dùng nguyên khối CW; form canh giữa khối con 880 */
.page { min-width: 0; display: flex; flex-direction: column; gap: 14px; }
.pageDetail, .pageTable { min-width: 0; }
.pageTool { flex: 1; min-height: 0; gap: 0; }
.content:has(> .pageTool) { width: 100%; max-width: none; margin: 0; padding: 0; gap: 0; min-height: 100%; }
.pageForm > * { width: min(880px, 100%); margin-inline: auto; }

/* đầu trang dính, thu gọn khi cuộn (26 → 18px, nền thẻ + bóng) */
.hdr {
  position: sticky;
  top: 0;
  z-index: 20;
  margin: calc(-1 * var(--pg-top, 22px)) -14px -2px; /* board: hdrH 42 + blkGap 12 (Mint-Job) */
  padding: var(--pg-top, 22px) 14px 0;
  display: flex;
  align-items: center;
  gap: 12px;
  background: var(--bg);
  border-radius: 0 0 14px 14px;
  transition: background 200ms, box-shadow 200ms, padding 200ms;
}
/* dense = đầu trang Mint-BLEdit: pad 18 / 12, hàng đầu 40, tiêu đề 24, dòng phụ cách 6 (opt-in) */
.hdr.dense { margin: calc(-1 * var(--pg-top, 22px)) -14px 0; padding: 18px 14px 12px; align-items: flex-start; }
.dense .hLead { min-height: 40px; }
.dense .hName { min-height: 40px; }
.dense .h1 { font-size: 24px; line-height: 1.4; }
.dense .hSub { margin-top: 6px; }
.dense .hName { flex-wrap: nowrap; overflow: hidden; }
.dense .h1 { flex-shrink: 0; overflow: visible; }
.dense .hMeta { flex-shrink: 1; overflow: hidden; }
.dense .hTabs { flex-shrink: 0; flex-grow: 1; justify-content: flex-end; }
.hdr.dense.cond { align-items: center; }
.hdr.dense.cond .h1 { font-size: 18px; line-height: 1.2; }
/* thu gọn: gom bằng bề ngang khối nội dung (CW), viền dưới + halo nền để nội dung cuộn phía sau không ló ở mép (QĐ 30/Oct 20:49, Mint-Customers / Mint-Job) */
.hdr:not(.cond) .hTx { min-height: var(--hdr-min, 0); }
.hdr[style*="--hdr-min"]:not(.cond) .hTx { display: flex; flex-direction: column; justify-content: center; }
.hdr.cond { margin-inline: 0; margin-bottom: 0; padding: 8px 18px; background: var(--card); border-bottom: 1px solid var(--line); box-shadow: -24px -1px 0 0 var(--bg), 24px -1px 0 0 var(--bg), 0 -24px 0 0 var(--bg), var(--sh); }
.hTx { flex-grow: 1; min-width: 0; }
.hTx:has(~ .hTabs) { flex-grow: 0; }
.hName { display: flex; align-items: center; flex-wrap: wrap; gap: 4px 8px; min-width: 0; }
.hLead { flex-shrink: 0; display: flex; align-items: center; gap: 8px; }
.hMeta { min-width: 0; display: flex; align-items: center; gap: 8px; }
.hAct { display: flex; align-items: center; flex-shrink: 0; }
.hTabs { flex-grow: 1; min-width: 0; display: flex; align-items: center; margin-left: 2px; }
.h1 { margin: 0; font-size: 26px; font-weight: var(--fw-title); letter-spacing: -0.02em; line-height: 1.2; transition: font-size 180ms; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.cond .h1 { font-size: 18px; }
.hCrumb { font-size: 12px; font-weight: 550; line-height: 1.2; white-space: nowrap; color: var(--lb); }
.cond .hCrumb { display: none; }
.hSub { margin-top: 2px; color: var(--lb); }
.cond .hSub { display: none; }
.hb {
  height: 42px;
  min-width: 42px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 0;
  border: 0;
  border-radius: 12px;
  background: var(--ctl);
  color: var(--tx2);
  font: inherit;
  font-weight: var(--fw-label);
  white-space: nowrap;
  cursor: pointer;
}
.hbFind { padding: 0 10px; }
.kbdTx { font-size: 12px; font-weight: var(--fw-label); color: var(--lb); }
.hbN { position: absolute; top: 3px; right: 3px; min-width: 15px; height: 15px; padding: 0 3px; box-sizing: border-box; border-radius: 8px; background: var(--err); color: var(--on-color); font-size: 9px; font-weight: 600; line-height: 15px; }
.kbd { padding: 1px 6px; border-radius: 6px; background: var(--card); font-size: 11px; font-weight: var(--fw-label); color: var(--lb); }
@media (hover: hover) {
  .hb:hover { color: var(--tx); background: var(--bd); }
}

/* ───────── ▦ chuyển vùng (APPS KIT) ───────── */
.apps {
  position: absolute;
  z-index: 58;
  width: 340px;
  max-width: calc(100vw - 24px);
  box-sizing: border-box;
  padding: 12px;
  border-radius: 16px;
  background: var(--card);
  color: var(--tx);
  box-shadow: var(--pop);
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.apAtSide { left: 12px; top: 58px; }
.apAtRail { left: 68px; top: 8px; }
.apAtFloat { left: 24px; top: 64px; }
.apHead { display: flex; align-items: center; gap: 8px; padding: 0 2px 0 6px; }
.apHead b { flex-grow: 1; font-weight: var(--fw-title); }
.apQ { display: flex; align-items: center; gap: 8px; height: 36px; padding: 0 10px; border-radius: 10px; background: var(--sub); color: var(--lb); }
.apQ input { flex-grow: 1; min-width: 0; border: 0; outline: 0; background: transparent; font: inherit; color: var(--tx); }
.apGrid { display: grid; grid-template-columns: 1fr 1fr; gap: 6px; }
.ap {
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-height: 72px;
  box-sizing: border-box;
  padding: 10px;
  border-radius: 12px;
  border: 1px solid transparent;
  color: var(--tx);
  text-decoration: none;
}
.ap[aria-current='page'] { background: var(--pri-bg); border-color: var(--pri-bd); }
.ap b { font-weight: var(--fw-label); }
.ap span:last-child { font-size: 12px; color: var(--lb); line-height: 1.3; }
.apNone { padding: 14px 6px; text-align: center; font-size: 12px; color: var(--lb); }
.apHub { display: flex; align-items: center; gap: 10px; height: 40px; padding: 0 10px; border-radius: 10px; background: var(--sub); color: var(--tx); text-decoration: none; font-weight: var(--fw-label); }
.apHub span:nth-child(2) { flex-grow: 1; }
@media (hover: hover) {
  .ap:not([aria-current='page']):hover { background: var(--sub); }
  .apHub:hover { background: var(--ctl); }
}
/* lưới vùng 6 ô trong bảng "Thêm" của điện thoại */
.apRow { display: grid; grid-template-columns: repeat(6, 1fr); gap: 2px; padding: 4px 0 10px; margin-bottom: 6px; border-bottom: 1px solid var(--line); }
.apMini { min-height: 64px; display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 4px; border-radius: 14px; color: var(--tx); text-decoration: none; font-size: 12px; font-weight: var(--fw-label); }
.apMini[aria-current='page'] { background: var(--pri-bg); color: var(--link); }

/* ───────── Ask HANA dock (vỏ) ───────── */
.fab {
  position: fixed;
  right: 24px;
  bottom: 24px;
  z-index: 50;
  width: 56px;
  height: 56px;
  padding: 0;
  border: 0;
  border-radius: 50%;
  overflow: hidden;
  background: var(--brand); /* cú Ask HANA phủ kín nút tròn, nền xanh (QĐ anh David 29/Oct 11:24) */
  color: var(--on-color);
  box-shadow: var(--sh-hi);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: transform 120ms ease, box-shadow 120ms ease;
}
.fab[aria-expanded='true'] { color: var(--on-color); }
.fab > :global(.hana-appicon) { transform: scale(1.18); }
@media (hover: hover) and (prefers-reduced-motion: no-preference) {
  .fab:hover { transform: translateY(-2px); }
}
.ask {
  position: fixed;
  right: 24px;
  bottom: 92px;
  z-index: 49;
  width: 420px;
  max-width: calc(100vw - 32px);
  height: min(560px, calc(100dvh - 120px));
  box-sizing: border-box;
  border: 1px solid var(--bd);
  border-radius: 16px;
  overflow: hidden;
  background: var(--card);
  color: var(--tx);
  box-shadow: var(--pop);
  display: flex;
  flex-direction: column;
}
.askHead { height: 64px; flex-shrink: 0; box-sizing: border-box; padding: 0 12px 0 16px; display: flex; align-items: center; gap: 10px; border-bottom: 1px solid var(--line); }
.askHead > div { flex-grow: 1; min-width: 0; }
.askHead b { font-size: 15px; font-weight: var(--fw-title); }
.askHead small { display: block; font-size: 12px; color: var(--lb); }
.askCtx { padding: 10px 16px; border-bottom: 1px solid var(--line); display: flex; align-items: center; gap: 8px; font-size: 12px; color: var(--lb); }
.askCtx span:last-child { height: 24px; padding: 0 8px; border-radius: 7px; background: var(--sub); color: var(--tx2); display: flex; align-items: center; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.askBody { flex-grow: 1; min-height: 0; overflow-y: auto; padding: 28px 16px 12px; display: flex; flex-direction: column; align-items: center; gap: 10px; text-align: center; color: var(--tx2); }
.askThread { width: 100%; display: flex; flex-direction: column; gap: 8px; text-align: left; font-size: 13px; line-height: 1.45; }
.askThread p { margin: 0; padding: 8px 12px; border-radius: 12px; max-width: 88%; white-space: pre-wrap; overflow-wrap: anywhere; }
.askMe { align-self: flex-end; background: var(--pri-bg); color: var(--tx); }
.askAi { align-self: flex-start; background: var(--skel); color: var(--tx); }
.askErr { align-self: flex-start; color: var(--danger); }
.askErr button { all: unset; cursor: pointer; text-decoration: underline; font-weight: var(--fw-label); }
.askBody b { color: var(--tx); font-size: 15px; font-weight: var(--fw-title); }
.askFoot { flex-shrink: 0; padding: 10px 16px 14px; border-top: 1px solid var(--line); }
.askIn { display: flex; gap: 8px; align-items: center; padding: 4px 4px 4px 12px; border-radius: 12px; border: 1px solid var(--bd); background: var(--sub); }
.askIn input { flex-grow: 1; min-width: 0; height: 36px; border: 0; outline: 0; background: transparent; color: var(--tx); font: inherit; }
.askSend { width: 32px; height: 32px; flex-shrink: 0; border: 0; border-radius: 9px; background: var(--brand); color: var(--on-color); display: flex; align-items: center; justify-content: center; cursor: pointer; }
.askSend:disabled { background: var(--ctl); color: var(--lb); cursor: default; }
.askNote { margin-top: 6px; font-size: 12px; color: var(--lb); }
@media (prefers-reduced-motion: no-preference) {
  .ask, .apps, .menu { animation: pop 180ms cubic-bezier(0.16, 1, 0.3, 1); }
}
@keyframes pop { from { opacity: 0; transform: translateY(4px); } }

/* ───────── Góp ý (vỏ) ───────── */
.ctx { display: flex; flex-wrap: wrap; gap: 6px; }
.fbLbl { font-size: 12px; font-weight: var(--fw-label); color: var(--lb); }
.ta {
  width: 100%;
  min-height: 120px;
  box-sizing: border-box;
  padding: 10px 12px;
  border-radius: 10px;
  border: 1px solid var(--bd);
  background: var(--inp);
  color: var(--tx);
  font: inherit;
  resize: vertical;
  outline: 0;
}
.ta:focus { border-color: var(--pri); box-shadow: var(--pri-ring); }

/* ───────── Tìm nhanh ───────── */
.qfList { display: flex; flex-direction: column; gap: 1px; margin: 0 -8px; }
.qfItem { display: flex; align-items: center; gap: 10px; min-height: 40px; padding: 0 10px; border-radius: 9px; color: var(--tx); text-decoration: none; }
.qfItem span:last-child { margin-left: auto; font-size: 12px; color: var(--lb); }
.qfItem[data-on='true'] { background: var(--sub); }
.qfEmpty { padding: 16px 8px; text-align: center; color: var(--lb); }

/* ───────── Điện thoại ───────── */
.phone { flex-direction: column; }
.pTop {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 5;
  flex-shrink: 0;
  box-sizing: border-box;
  height: calc(56px + env(safe-area-inset-top));
  padding: env(safe-area-inset-top) 8px 0 16px;
  display: flex;
  align-items: center;
  gap: 4px;
  background: var(--bg);
  transition: transform 260ms cubic-bezier(0.16, 1, 0.3, 1), box-shadow 200ms;
}
.pTop.hide { transform: translateY(-100%); }
.pTop.cond { background: var(--card); box-shadow: var(--sh); border-radius: 0 0 14px 14px; }
.pTitle { flex-grow: 1; min-width: 0; display: flex; align-items: center; gap: 10px; font-size: 17px; font-weight: var(--fw-title); }
.pTitle span { white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.pb { width: 44px; height: 44px; flex-shrink: 0; border: 0; border-radius: 12px; background: transparent; color: var(--tx2); display: flex; align-items: center; justify-content: center; cursor: pointer; }
.phone .main { height: auto; flex-grow: 1; scrollbar-gutter: auto; padding-top: calc(56px + env(safe-area-inset-top)); }
.phone .content { width: auto; padding: 4px 16px calc(110px + env(safe-area-inset-bottom)); gap: 12px; }
.phone .content:has(> .pageTool) { padding: 0 0 calc(76px + env(safe-area-inset-bottom)); }
.phone .hdr { position: static; margin: 0; padding: 0; background: transparent; }
.phone .h1 { font-size: 22px; }
.tabs {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 8;
  display: flex;
  padding: 8px 8px calc(8px + env(safe-area-inset-bottom));
  background: var(--card);
  border-top: 1px solid var(--line);
  transition: transform 260ms cubic-bezier(0.16, 1, 0.3, 1);
}
.tabs.hide { transform: translateY(100%); }
.tab {
  position: relative;
  flex: 1 1 0;
  min-height: 48px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 3px;
  border: 0;
  background: transparent;
  color: var(--lb);
  font: inherit;
  font-size: 12px;
  font-weight: var(--fw-label);
  text-decoration: none;
  cursor: pointer;
}
.tab[aria-current='page'] { color: var(--pri); }
.tab span { max-width: 100%; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.phone .fab { bottom: calc(84px + env(safe-area-inset-bottom)); right: 16px; }
.phone .ask { right: 0; left: 0; bottom: 0; width: 100%; max-width: none; height: 86dvh; border-radius: 22px 22px 0 0; }
.sheet {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 61;
  max-height: 86dvh;
  box-sizing: border-box;
  padding: 8px 14px calc(16px + env(safe-area-inset-bottom));
  border-radius: 22px 22px 0 0;
  background: var(--card);
  color: var(--tx);
  box-shadow: var(--pop);
  display: flex;
  flex-direction: column;
}
.grab { width: 40px; height: 5px; flex-shrink: 0; margin: 0 auto 6px; border-radius: 3px; background: var(--bd); }
.sheetHead { display: flex; align-items: center; height: 52px; flex-shrink: 0; padding: 0 4px 0 12px; }
.sheetHead b { flex-grow: 1; font-size: 18px; font-weight: var(--fw-title); }
.sheet .scrimTop { z-index: 60; }

/* chạm: vùng chạm 44 / 48 */
.touch .item, .touch .grp, .touch .mi { height: 44px; border-radius: 12px; padding: 0 12px; gap: 12px; }
.touch .sub .item { height: 44px; }
.touch .ib, .touch .hb { width: 44px; height: 44px; min-width: 44px; border-radius: 12px; }
.touch .hbFind { width: auto; }
.phone .hdr .hb { width: 48px; height: 48px; min-width: 48px; }
.sheet .item, .sheet .grp, .sheet .mi { height: 48px; font-size: 16px; }
.sheet .sub .item { height: 48px; font-size: 15px; }
.sheet .sec { font-size: 12px; padding: 16px 12px 4px; }

@media (prefers-reduced-motion: reduce) {
  *, *::before, *::after { transition: none !important; animation-duration: 0.01ms !important; }
}

/* Rail có nhãn 80 (vùng khai rail: 'labeled', board Mint-Mee): nút 68×54, icon 20, nhãn 12/550, huy hiệu số 18 */
.lrail { position: relative; width: 80px; height: 100%; box-sizing: border-box; padding: 12px 0; display: flex; flex-direction: column; align-items: center; gap: 4px; overflow-y: auto; scrollbar-width: none; }
.lbrand { margin-bottom: 8px; flex-shrink: 0; }
.lb {
  position: relative;
  width: 68px;
  height: 54px;
  flex-shrink: 0;
  border: 0;
  border-radius: 12px;
  background: transparent;
  color: var(--tx2);
  font: inherit;
  font-size: 12px;
  font-weight: 550;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 3px;
  cursor: pointer;
  text-decoration: none;
}
.lb[aria-current='page'] { background: var(--pri-bg); color: var(--link); }
.lbEnd { margin-top: auto; }
.lsep { width: 28px; height: 1px; flex-shrink: 0; margin: 6px 0; background: var(--line); }
.lbadge { position: absolute; top: 3px; right: 8px; min-width: 18px; height: 18px; padding: 0 5px; box-sizing: border-box; border-radius: 9px; background: var(--pri); color: var(--btn-tx); font-size: 12px; font-weight: 600; line-height: 18px; text-align: center; }
@media (hover: hover) {
  .lb:not([aria-current='page']):hover { background: var(--sub); color: var(--tx); }
}
